import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';
import useTranslation from 'next-translate/useTranslation';

export default function PremiumNoticeModal({ open, onClose, onUpgrade }) {
  const { t } = useTranslation('common');
  return (
    <Dialog open={Boolean(open)} onClose={onClose} aria-labelledby="premium-dialog-title">
      <DialogTitle id="premium-dialog-title">{t('Premium Feature')}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          {t('This feature is available for users with premium access.')}
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {t('To switch to the property account and view conversations through the property account, please upgrade your package to premium.')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">{t('Close')}</Button>
        <Button
          onClick={() => {
            const url = 'https://superkos.id/pricing/';
            if (typeof window !== 'undefined' && window.open) {
              window.open(url, '_blank', 'noopener,noreferrer');
            }
            if (typeof onUpgrade === 'function') {
              onUpgrade();
            } else {
              onClose();
            }
          }}
          color="primary"
          variant="contained"
        >
          {t('Learn More & Upgrade')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
